export default class Accordion {
    constructor () {
        this.accordion = document.querySelectorAll('.accordion')

        // If there's no accordion, return
        if (!this.accordion)
            return

        this.accordion.forEach(accordion =>
            accordion.addEventListener(
                'click',
                this.update.bind(this)
            )
        )
    }

    update (el) {
        const selector = '.accordion-title'
        const accordion = el.target.closest('.accordion')
        const current = el.target.closest(selector)
        const items = accordion.querySelectorAll(selector)

        if (current && items.length > 1)
            items.forEach(item => {
                if (item === current) {
                    item.classList.toggle('accordion-title-open')
                    if (item.classList.contains('accordion-title-open'))
                        this.ensureVisible(item)
                }
                else
                    item.classList.remove('accordion-title-open')
            })
    }

    ensureVisible (item) {
        setTimeout(() => {
            const elementPosition = item.getBoundingClientRect().top
            const offsetPosition = elementPosition + window.scrollY - 120

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            })
        }, 250)
    }
}
